import localforage from "localforage";

let checkoutStore = {
  "userdetails": {},
  "Payment": {},
  "plansDetail": {}
}

const updateCheckoutStore = async ({ userDetails, paymentDetails, plansDetail }) => {
  try {

    const AuthenticationStore = await localforage.getItem('AuthenticationStore')
    let user = AuthenticationStore?.user
    if (user) {
      userDetails = user
    }
    let checkoutStore = await localforage.getItem('CheckoutStore');
    if (checkoutStore) {
      checkoutStore = { userDetails: { ...checkoutStore.userDetails, ...userDetails }, paymentDetails: { ...checkoutStore.paymentDetails, paymentDetails }, plansDetail: { ...checkoutStore.plansDetail, plansDetail } }
      localforage.setItem('CheckoutStore', checkoutStore)
    } else {
      checkoutStore = { userDetails, paymentDetails, plansDetail }
      localforage.setItem('CheckoutStore', checkoutStore)
    }
    return checkoutStore;
  } catch (err) {
    console.error('Error updating Checkout store:', err);
    throw err;
  }
};

const fetchCheckoutStore = async () => {
  let checkoutStore = await localforage.getItem('CheckoutStore');
  return checkoutStore
}

export { updateCheckoutStore,fetchCheckoutStore }